import { tns } from 'tiny-slider/src/tiny-slider';

const $galleries = document.querySelectorAll('.act-gallery-cover__gallery');

if (location.pathname.indexOf('wp-admin') === -1) {
    if ($galleries.length > 0) {
        var slider = tns({
            mode: 'gallery',
            //animateIn: 'fadeInDown',
            //animateOut: 'fadeOutDown',
            animateDelay: 750,
            autoplayTimeout: 6000,
            controls: false,
            container: '.act-gallery-cover__gallery',
            autoplay: true,
            autoplayButton: false,
            nav: false,
        });
    }
}

(function ($) {
    $(document).ready(function () {
        if ($('.l-scroll').length) {
            $('body').on('click', '.l-scroll', function () {
                var $scrollTo = $('.act-gallery-cover').next();
                $("html, body").animate({ scrollTop: $scrollTo.offset().top - $(".l-header").height() + 2} );

            });

        }
    });
})(jQuery);
